export default "__VITE_ASSET__DAxC1ef9__"